import { ActionIcon, Popover, TextInput, Textarea, useMantineTheme } from "@mantine/core";
import React, { useContext, useState } from "react";
import { IconCode } from "@tabler/icons";
import { DataFlowContext } from "../../core/context/DataFlowContext";

const VariableSelectWrite = ({textareaRef, label, placeholder, dataState, handleData, handleSelect, description, className, style, disabled=false, ...props}) => {
    const [openDropdown, setOpenDropdown] = useState(false)
    const dataSelect = useContext(DataFlowContext)
    const theme = useMantineTheme()
    const isTet = theme.colorScheme === 'tet'
    const handleDropdown = () => {
        setOpenDropdown(!openDropdown)
    }
    const handleClickSelect = (e)=>{
        handleSelect(e)
        setOpenDropdown(false)
    }
    const rightSection = (<ActionIcon radius="md" onClick={handleDropdown} variant="gradient"
        gradient={
            isTet
                ? { from: '#d32f2f', to: '#fbc02d', deg: 90 }
                : { from: '#f08c00', to: '#f08c00', deg: 90 }
        }><IconCode size={16} /></ActionIcon>)
    return (
        <>
            <Popover disabled={disabled} opened={openDropdown} width="target" position="bottom" shadow="md">
                <Popover.Target>
                    <Textarea
                        ref={textareaRef}
                        style={style}
                        className={className}
                        placeholder={placeholder}
                        value={typeof dataState === 'object' ? JSON.stringify(dataState, null, 2) : dataState}
                        label={label}
                        mt="xs"
                        description={description}
                        onChange={handleData}
                        rightSection={rightSection}
                        autosize
                        minRows={2}
                        disabled={disabled}
                        {...props}
                    />
                </Popover.Target>
                <Popover.Dropdown style={{ maxHeight: '40vh', overflow: 'auto' }}>
                    {dataSelect.nodeValue.variables.map((ele, index) => {
                        return (
                            <li
                                key={index}
                                onClick={(e) => handleClickSelect(e)}
                                value={ele.value}
                            >
                                {ele.label}
                            </li>
                        )
                    })}
                </Popover.Dropdown>
            </Popover>
        </>
    )
}

export default VariableSelectWrite;